import { Link } from 'react-router';

import Text, {
  type ResponsiveTextToken,
  type TextLeading,
  type TextToken,
} from '@cartwhl/ui/base/TextNew';
import ChevronRightIcon from '@cartwhl/ui/icons/ChevronRightIcon';

type GreenLinkToken = TextToken | ResponsiveTextToken;

interface GreenLinkProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  token?: GreenLinkToken;
  leading?: TextLeading;
}

function isExternalHref(href: string) {
  return href.startsWith('mailto:') || href.startsWith('http');
}

export default function GreenLink({
  children,
  href,
  onClick,
  className,
  token = { base: 'display/20/bold', lg: 'display/32/bold' },
  leading,
}: GreenLinkProps) {
  const baseClassName = `transition-color hover:text-green-60 cursor-pointer text-green-50 ${className}`;

  const content = (
    <Text
      as="span"
      token={token}
      leading={leading}
      className="flex items-center"
    >
      {children}
      <ChevronRightIcon className="-mt-0.5 h-7 w-7 lg:h-10 lg:w-10" />
    </Text>
  );

  if (href) {
    return (
      <Link
        to={href}
        className={baseClassName}
        {...(isExternalHref(href)
          ? { target: '_blank', rel: 'noopener noreferrer' }
          : {})}
      >
        {content}
      </Link>
    );
  }

  return (
    <button onClick={onClick} className={`text-left ${baseClassName}`}>
      {content}
    </button>
  );
}
